/**
 * This will watch a video item for viewport intersection
 * On intersection some elements will be added
 * @example ng-video-item=""
 */

const ngNativeClick = ['$http', ($http) => {
    return {
        scope: { id: '=ngNativeClick'},

        link: ( $scope, $item, $params ) => {
            $item[0].addEventListener(('ontouchstart' in document.documentElement ? "touchstart" : "click"), () => {
                $http.get(window.variables.native.trackClickUrl, { params: { id: $scope.id } })
            });
        }
    };
}];

export default ngNativeClick;

